<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-title class="headline">切换区块链网络</v-card-title>
      <v-card-text>
        <v-select
          v-model="selectedNetwork"
          :items="networks"
          label="选择网络"
          item-title="name"
          item-value="id"
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">取消</v-btn>
        <v-btn color="blue darken-1" text @click="switchNetwork">切换</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      selectedNetwork: null,
      networks: [
        { id: '1', name: 'Ethereum Mainnet' },
        { id: '3', name: 'Ropsten Testnet' },
        { id: '4', name: 'Rinkeby Testnet' },
        { id: '5', name: 'Goerli Testnet' },
        { id: '42', name: 'Kovan Testnet' },
        { id: '56', name: 'Binance Smart Chain' },
        { id: '97', name: 'Binance Smart Chain Testnet' },
        { id: '137', name: 'Polygon Mainnet' },
        { id: '80001', name: 'Polygon Testnet' },
      ],
    };
  },
  methods: {
    switchNetwork() {
      // 在这里添加切换网络的逻辑
      console.log(`切换到网络: ${this.selectedNetwork}`);
      if(this.selectedNetwork === '56' || this.selectedNetwork === '97') {
        localStorage.setItem('targetNetwork', this.selectedNetwork);
      } else {
        this.$toast.error('请切换到Binance Smart Chain或Binance Smart Chain Testnet');
      }
      this.dialog = false;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
/* 添加自定义样式（如果需要） */
</style>
